import React, { createContext } from 'react';

/** 创建 state 作用域 */
export const StoreContext = createContext<object | null>(null);

export const StoreProvider: React.FC<{ children: React.ReactNode; state: object }> = ({ children, state }) => {
    return <StoreContext.Provider value={state}>{children}</StoreContext.Provider>;
};
